module.exports = __webpack_public_path__ + "img/ShapeList.5446dccf.svg";